import { render, staticRenderFns } from "./works_video.vue?vue&type=template&id=e60ea18e&scoped=true&"
import script from "./works_video.vue?vue&type=script&lang=js&"
export * from "./works_video.vue?vue&type=script&lang=js&"
import style0 from "./works_video.vue?vue&type=style&index=0&id=e60ea18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60ea18e",
  null
  
)

export default component.exports